import Ddl from '../../../models/common/Ddl';
import EWalletConst from '../../consts/EWalletConst';
import NumberUtility from '../number-utility';
import EuroUtility from '../euro-utility';
import EWalletUtility from '../e-wallet-utility/EWalletUtility';
import CurrencyUtility from '../currency-utility/CurrencyUtility';

const EWalletPredefinedValueUtility = {
    getAsDdl(): Ddl[] {
        const primaryCurrency = CurrencyUtility.getPrimary();
        const secondaryCurrency = CurrencyUtility.getSecondary();
        
        const ddls = EWalletUtility.getPredefinedValues().map(predefinedValue => (
            {
                id: predefinedValue,
                value: `${NumberUtility.format(predefinedValue, 2, true, false, ',')} ${primaryCurrency.sign}`,
                secondaryValue: `(${EuroUtility.convert(predefinedValue)} ${secondaryCurrency.sign})`
            } as Ddl)
        );

        return ddls;
    },

    getPredefinedValuesBelowLimit(value?: number): number[] {
        return EWalletUtility.getPredefinedValues()
            .filter(predefinedValue => this.isBelowLimit(predefinedValue, value))
    },

    isBelowLimit(predefinedValue: number, value?: number): boolean {
        if (value === undefined)
            return false;

        const isBelowLimit = value + predefinedValue <= EWalletConst.getMaxEWalletAmount();

        return isBelowLimit;
    },

    maxOtherAmount(currentAmount: number): number {
        return EWalletConst.getMaxEWalletAmount() - currentAmount;
    }
}

export default EWalletPredefinedValueUtility;
